import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { type FormFieldComponentProps } from "../../../lib/types/types";
import { FormFieldText } from "../FormFieldText/FormFieldText";
import { useFlag } from "../../FeatureFlags/hooks";

interface PassedProps {
  explanation?: string | JSX.Element;
}

export const CVECNumberComponent = ({
  value,
  isErrored,
  onChange,
  explanation,
  placeholder = "",
  isRequired = false,
}: FormFieldComponentProps & PassedProps) => {
  const { msg } = useMessage();
  // #region include-cvec-field-france-student
  const showCvecInputVariation = useFlag("include-cvec-field-france-student");

  const getDefaultExplanation = () =>
    showCvecInputVariation === "labeled-optional" ? (
      <FormattedHTMLMessage
        id="cvecNumberExplanation"
        defaultMessage="Optional - Add your CVEC number to increase your chances of being verified instantly."
      />
    ) : (
      <FormattedHTMLMessage
        id="_EXPERIMENTAL.cvecNumberExplanation"
        defaultMessage="Add your CVEC number to increase your chances of being verified instantly."
      />
    );
  // #endregion include-cvec-field-france-student

  const isFieldHidden = getFieldConfigByFieldId("cvecNumber")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="cvecNumber"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "cvecNumber" })}
      label={<FormattedHTMLMessage id="cvecNumber" defaultMessage="CVEC certificate number" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidCvecNumber"
            defaultMessage="Invalid CVEC certificate number"
          />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      required={isRequired}
      explanation={explanation || getDefaultExplanation()}
    />
  );
};
